<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :model="formInline" class="demo-form-inline" label-width="160px">
      <el-form-item label="联系我们（手机号）：" prop="callUs">
        <el-input v-model="formInline.callUs" clearable style="width: 400px;" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="关于我们：">
        <div class="rich-text-editor">
          <!-- 富文本编辑器组件 -->
          <QuillEditor 
            v-model:content="formInline.aboutUs" 
            contentType="html" 
            :options="editorOptions" 
            @update:content="handleContentChange"
            class="editor" 
          />
          <!-- 预览区域 -->
          <div class="preview">
            <h3>预览：</h3>
            <div v-html="formInline.aboutUs" class="preview-content"></div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { InfoFilled, ArrowRightBold, ArrowDownBold } from "@element-plus/icons-vue";
import service from "@/http/request.js";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css' // 引入雪主题样式

// 编辑器配置项
const editorOptions = {
  theme: 'snow',
  modules: {
    toolbar: [
      // 添加 size 工具栏选项，用于调整字体大小
      [{ 'size': ['small', false, 'large', 'huge'] }], // 对应 '10px', '13px', '18px', '32px'
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ],
  },
  // 如果需要自定义像素尺寸，可以在这里配置
  // formats: ['size'], // 明确指定允许的格式，虽然默认已包含
}

// 内容变化时的回调
const handleContentChange = (content) => {
  console.log('编辑器内容变化：', content)
  // 可在此处处理内容，如同步到后端等
}

const formInline = reactive({
  callUs: "",
  aboutUs: "",
});
const searchFormRef = ref();

const onSubmit = () => {
  service.post('/health/web/publicDescription/save', formInline)
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        ElMessage.success("保存成功");
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

onMounted(() => {
  service.get('/health/web/publicDescription/webData', {})
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        formInline.callUs = data.data.data.callUs
        formInline.aboutUs = data.data.data.aboutUs
        formInline.id = data.data.data.id
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
});

const handleToggle = (row) => {
  row.expanded = !row.expanded;
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}

.rich-text-editor {
  max-width: 800px;
}

.editor {
  height: 300px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}

.preview {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}

.preview-content {
  min-height: 100px;
  max-height: 500px;
  overflow-y: auto;
}
</style>